"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TitleCard = _interopRequireDefault(require("./templates/TitleCard.html"));

var _TitleInfo = _interopRequireDefault(require("./views/TitleInfo"));

var _TitleActionButton = _interopRequireDefault(require("./TitleActionButton"));

var _WishListButton = _interopRequireDefault(require("./WishListButton"));

var _TitleHeaderBar = _interopRequireDefault(require("./TitleHeaderBar"));

var _Cover = _interopRequireDefault(require("./Cover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TitleCard =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(TitleCard, _Backbone$View);

  _createClass(TitleCard, [{
    key: "className",
    get: function get() {
      return 'title-container title';
    }
  }]);

  function TitleCard(_ref) {
    var _this;

    var coverWidths = _ref.coverWidths,
        _ref$isInHero = _ref.isInHero,
        isInHero = _ref$isInHero === void 0 ? false : _ref$isInHero;

    _classCallCheck(this, TitleCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitleCard).apply(this, arguments));
    _this.template = _TitleCard["default"];
    _this._views = [];
    _this.coverWidths = coverWidths;
    _this.isInHero = isInHero;

    _this.render();

    return _this;
  }

  _createClass(TitleCard, [{
    key: "render",
    value: function render() {
      var model = this.model,
          coverWidths = this.coverWidths,
          isInHero = this.isInHero;
      this.$el.empty();

      this._views.forEach(function (view) {
        return view.remove();
      });

      this._views = [];
      var $tmp = $(this.template()); // TODO: This will not work  with CSS transition animations

      if (this.model.isPlaceholder) {
        this.$el.addClass('placeholder');
      }

      this._views.push(this.titleHeaderBar = new _TitleHeaderBar["default"]({
        model: model,
        el: $tmp.find('.TitleHeaderBar')
      }));

      this._views.push(this.cover = new _Cover["default"]({
        model: model,
        el: $tmp.find('.CoverImage'),
        coverWidths: coverWidths,
        isInHero: isInHero
      }));

      this._views.push(this.titleInfo = new _TitleInfo["default"]({
        model: model,
        el: $tmp.find('.TitleInfo')
      }));

      this._views.push(this.titleActionButton = new _TitleActionButton["default"]({
        model: model,
        el: $tmp.find('.TitleAction')
      }));

      if (!window.featureManager.isEnabled('internationalDemoMode')) {
        this._views.push(this.wishlistButton = new _WishListButton["default"]({
          model: model,
          el: $tmp.find('.TitleWishlist'),
          type: 'icon-only'
        }).render());
      }

      this.$el.append($tmp);
      return this;
    }
  }, {
    key: "remove",
    value: function remove() {
      this._views.forEach(function (view) {
        return view.remove();
      });

      _get(_getPrototypeOf(TitleCard.prototype), "remove", this).call(this);
    }
  }]);

  return TitleCard;
}(Backbone.View);

exports["default"] = TitleCard;